<template>
  <div class="page">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('afterSales.text39')" style="width:280px;margin-right:25px;">
          <el-input clearable v-model="searchParams.keyword" :placeholder="$t('public.text1')"/>
        </el-form-item>
        <el-form-item :label="$t('afterSales.text41')" style="width:250px;margin-right:25px;">
          <el-select v-model="searchParams.status" :placeholder="$t('public.text5')">
            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text45')">
          <el-date-picker
            v-model="searchParams.startAt"
            type="date"
            value-format="yyyy-MM-dd"
            style="width:150px;"
            :placeholder="$t('public.text2')"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
          <span style="margin: 0 8px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="date"
            value-format="yyyy-MM-dd"
            style="width:150px;"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOption1"
          >
          </el-date-picker>
        </el-form-item>
        <div class="searchSubmit">
          <DiluButton type="search" @click="loadWorkOrder"/>
        </div>
      </el-form>
    </div>
    <DiluTable :list="tableData" :tableConfig="tableConfig" :total="total" :pageSize="searchParams.pageSize" @currentChange="currentChange">
      <el-table-column prop="id" label="ID" width="90" align="left"/>
      <el-table-column prop="appAccount" :label="$t('pages.user.text5')" width="180" align="left"/>
      <el-table-column prop="status" :label="$t('afterSales.text41')" width="120" align="lefft">
        <template slot-scope="scope">
          <span v-if="scope.row.status==10">{{$t("afterSales.text42") }}</span>
          <span v-if="scope.row.status==20">{{$t("afterSales.text43") }}</span>
          <span v-if="scope.row.status==30">{{$t("afterSales.text44") }}</span>
          <span v-if="scope.row.status==40">{{$t("afterSales.text45") }}</span>
          <span v-if="scope.row.status==50">{{$t("afterSales.text46") }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="faultLevel" :label="$t('afterSales.text47')" width="100" align="lefft">
        <template slot-scope="scope">
          <span v-if="scope.row.faultLevel=='high'">{{$t("afterSales.text49") }}</span>
          <span v-if="scope.row.faultLevel=='middle'">{{$t("afterSales.text50") }}</span>
          <span v-if="scope.row.faultLevel=='low'">{{$t("afterSales.text51") }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="subject" :label="$t('afterSales.text48')" width="120" align="left"/>
      <el-table-column prop="faultInfo" :label="$t('afterSales.text38')" width="250" align="left"/>
      <el-table-column prop="createdAt" :label="$t('afterSales.text36')" width="160" align="left"/>
      <el-table-column prop="address" :label="$t('public.text4')" width="150" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="orderDetail(scope.row)" type="text">{{ $t("afterSales.text38") }}</el-button>
          </div>
        </template>
      </el-table-column>
    </DiluTable>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DiluButton from "/src/components/pubilc/dilu-button.vue";
import DiluTable from "/src/components/pubilc/dilu-table.vue";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOption1: {
        //选中的开始日期前的时间禁选
        disabledDate: (time) => {
          return time.getTime() < this.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      searchParams: {
        keyword: null, 
        startAt: null,
        stopAt: null,
        status: null,
        pageNum: 1, 
        pageSize: 10, 
      }, // 搜索条件
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      tableData: [],
      total: 0,
      isSerch: false, 
      statusList: [
        {
          "id": 10,
          "name": this.$t("afterSales.text42")
        },
        {
          "id": 30,
          "name": this.$t("afterSales.text43")
        },
        {
          "id": 40,
          "name": this.$t("afterSales.text44")
        },
        {
          "id": 50,
          "name": this.$t("afterSales.text45")
        },
        {
          "id": 60,
          "name": this.$t("afterSales.text46")
        }
      ],
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  components: {
    DiluTable,
    DiluButton,
  },
  mounted() {
    this.loadWorkOrder();
  },
  methods: {
    loadWorkOrder() {
      const that=this;
      that.request.workOrderList(that.searchParams).then((res) => {
        if (res.code==0) {
          this.tableData = res.data;
          this.total = res.dataMaxCount;
        }
      });
    },
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.loadWorkOrder();
    },
    //回复工单
    orderDetail(e) {
      this.$router.push({
        path: "/afterSales/serviceMgt/replyOrder",
        query: {
          workOrder: e
        },
      });
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams.pageNum = 1;
        this.searchParams.pageSize = 10;
      }
      this.searchParams.pageNum = e;
      this.loadWorkOrder();
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
  margin-left: 10px;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
.search {
  margin-bottom: 20px;
}
</style>